import React, { createContext } from 'react'
import { BaseContextState, BaseContextProvider } from '../BaseContext'
import { SearchRequest } from '../../services/api/interfaces/ApiRequest'
import { invoiceList, invoiceSetPaid } from '../../services/api'

interface InvoiceContextState extends BaseContextState {
  invoices: any[] | null,
  invoice: any | null,
  filters?: any
}

export interface InvoiceContextData extends InvoiceContextState {
  resetErrors: Function,
  requestInvoiceList: (args: SearchRequest) => Promise<any>,  
  requestInvoiceFind: (args: SearchRequest) => Promise<any | null>,
  requestInvoiceSetPaid: (args: any) => Promise<any>,
}

// Create context
const { Provider, Consumer } = createContext({} as InvoiceContextData)

// Export consumer
export const InvoiceConsumer = Consumer

export class InvoiceProvider extends BaseContextProvider {
  state: InvoiceContextState = {
    invoices: null,
    filters: null,
    invoice: null
  }

  /**
   * Make api request for invoice list
   * 
   * @param {SearchRequest} payload 
   */
  requestInvoiceList = (payload: SearchRequest) => {
    this.setState({filters: payload})
    return new Promise((resolve, reject) => {
      this.setState({
        fetching: true,
        error: null,
        invoices: null
      }, async () => {
        const response = await invoiceList(payload)
  
        // Process our response
        this.processResponse(response, { 
          paginate: {
            destination: 'invoices'
          },
        })

        if (this.state.success) {
          resolve(true)
        } else {
          reject(this.state.error)
        }
      })
    })
  }

  requestInvoiceSetPaid = (payload: any) => {
    return new Promise((resolve, reject) => {
      this.setState({
        fetching: true,
        error: null,
      }, async () => {
        const response = await invoiceSetPaid(payload)
        
        this.processResponse(response, { 
          paginate: {
            destination: 'invoices'
          },
        })
        
        if (this.state.success) {
          resolve(true)
        } else {
          reject(this.state.error)
        }
      })
    })
  }

  /**
   * Make api request for invoice finder
   * 
   * @param {SearchRequest} payload 
   */
  requestInvoiceFind = (payload: SearchRequest): Promise<any | null> => {
    return new Promise((resolve, reject) => {
      this.setState({
        fetching: true,
        error: null,
        invoice: null
      }, async () => {
        payload.options = {
          ...payload.options,
          _single: true
        }
        const response = await invoiceList(payload)
  
        // Process our response
        this.processResponse(response, { 
          mappings: {
            destination: 'invoice'
          },
        })

        if (this.state.success) {
          resolve(this.state.invoice)
        } else {
          reject(this.state.error)
        }
      })
    })
  }

  render() {
    return (
      <Provider
        value={{
          // States
          ...this.state,

          // Dispatches
          resetErrors: this.resetErrors,
          requestInvoiceList: this.requestInvoiceList,
          requestInvoiceFind: this.requestInvoiceFind,
          requestInvoiceSetPaid: this.requestInvoiceSetPaid,
        }}
      >
        {this.props.children}
      </Provider>
    )
  }
}
